/** helper function to add item to array, overwriting existing entry*/
export const remove = (array = [], item) => {
  return [...array.filter((i) => i !== item)];
};
